export const initializeCredentialsDropdown = ({select, container, mxResources, toResults, onChange, onLoaded}) => {
    if (select.dataset.credentialsDropdownInitialized === 'true') {
        return;
    }
    select.dataset.credentialsDropdownInitialized = 'true';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ui mini icon button';
    button.dataset.credentialsRefresh = 'true';
    button.setAttribute('aria-label', mxResources.get('credentialsRefresh'));
    button.title = mxResources.get('credentialsRefresh');
    button.disabled = select.disabled;
    const icon = document.createElement('i');
    icon.className = 'refresh icon';
    icon.setAttribute('aria-hidden', 'true');
    button.appendChild(icon);
    let failed = false;
    $(select).dropdown({
        duration: 0,
        transition: {showMethod: 'none', hideMethod: 'none'},
        filterRemoteData: true,
        saveRemoteData: false,
        fullTextSearch: true,
        clearable: true,
        message: {serverError: mxResources.get('credentialsRefreshFailed')},
        apiSettings: {
            url: '/api/credentials',
            cache: 'local',
            rawResponse: true,
            interruptRequests: false,
            className: {loading: ''},
            data: {editor: container.credentialsCacheNamespace},
            onResponse: toResults,
            onRequest: () => {
                button.disabled = true;
                button.classList.add('loading');
            },
            onComplete: () => {
                button.disabled = select.disabled;
                button.classList.remove('loading');
            },
            onFailure: () => { failed = true; dropdown.dropdown('show'); },
            onError: () => { failed = true; dropdown.dropdown('show'); },
            onSuccess: response => {
                failed = false;
                if (!container.contains(select)) {
                    return;
                }
                dropdown.api('write cached response', '/api/credentials', response);
                const selected = select.value;
                const item = response.results.find(item => item.value === selected);
                const available = Boolean(item);
                if (item) {
                    dropdown.dropdown('set text', item.text);
                }
                if (selected && !available) {
                    dropdown.dropdown('add message', mxResources.get('credentialsUnavailable'));
                }
                updateSelection(selected, item);
            }
        },
        onChange: value => {
            if (container.contains(select)) {
                const response = dropdown.api('read cached response', '/api/credentials');
                const item = response?.results?.find(item => item.value === value);
                updateSelection(value, item);
                onChange?.(value);
            }
        },
        onShow: () => {
            if (failed) {
                dropdown.dropdown('add message', mxResources.get('credentialsRefreshFailed'));
            } else {
                dropdown.dropdown('queryRemote', '', () => {});
            }
        }
    });
    const dropdownElement = select.closest('.ui.dropdown') || select;
    const dropdown = $(dropdownElement);
    const action = document.createElement('div');
    action.className = 'ui fluid action input';
    dropdownElement.parentNode.insertBefore(action, dropdownElement);
    action.appendChild(dropdownElement);
    action.appendChild(button);
    const authorization = document.createElement('div');
    authorization.className = 'ui top pointing basic large label';
    authorization.setAttribute('data-credentials-authorization', '');
    const authorizationLink = document.createElement('a');
    authorizationLink.setAttribute('target', '_blank');
    authorizationLink.setAttribute('rel', 'noopener noreferrer');
    authorization.appendChild(authorizationLink);
    const updateSelection = (value, item) => {
        authorization.remove();
        if (!select.disabled && item?.credentialType === 'OAUTH2') {
            authorizationLink.setAttribute('href', `/credentials/${value}/authorize`);
            authorizationLink.textContent = mxResources.get(item.authorized === true
                ? 'reauthorizeCredentials' : 'authorizeCredentials', [value]);
            action.insertAdjacentElement('afterend', authorization);
        }
        onLoaded?.(value, Boolean(item), item);
    };
    const refresh = event => {
        event.preventDefault();
        event.stopPropagation();
        if (!button.disabled) {
            failed = false;
            dropdown.dropdown('clear cache');
            dropdown.dropdown('queryRemote', '', () => {});
        }
    };
    button.addEventListener('click', refresh);
    select.destroyCredentialsDropdown = () => {
        authorization.remove();
        button.removeEventListener('click', refresh);
        dropdown.api('abort');
        dropdown.api('destroy');
        dropdown.dropdown('destroy');
    };
    if (select.value) {
        dropdown.dropdown('queryRemote', '', () => {});
    }
};
